import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-meta-table-datas',
  templateUrl: './meta-table-datas.component.html',
  styleUrls: ['./meta-table-datas.component.css']
})
export class MetaTableDatasComponent implements OnInit {
    public itemsListMetaTableDatas: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadMetaTableDatas() {
        this.itemsListMetaTableDatas = await this.datatask.Post(2385);
    }

    private async init() {
        this.loadMetaTableDatas();
    }

    ngOnInit() {
        this.init();
    }
}
